<template>
    <div>
        <e-dialog
                dialog-title="石化订单"
                dialogType="other"
                :center-dialog-visible="stockAffirmVisible"
                popup-width="840px"
                :isShowConfirm="false"
                @resetPopupData="handleClose">
            <e-tab class="tabs-area margin-b20"
                   :tabs-value="activeIndex"
                   :tab-pane-data="tabArr"
                   @tabClick="handleClick"></e-tab>

            <tableList
                    class="margin-t20"
                    rowKey="companyId"
                    maxHeight="360"
                    :loading="loading"
                    :table-data="tableData"
                    :table-label="tableLabel">
                <template v-slot:showIndex="slot">
                    {{ (queryData.pageNum - 1) * queryData.pageSize + slot.scope.$index + 1}}
                </template>
                <template #operate="{ scope: { row } }">
                    <eui-btn type="text" @click="viewDetail(row.id,row.type)">查看详情</eui-btn>
                </template>
            </tableList>
            <!--查看详情-->
            <detail-dialog
                    v-if="viewDetailVisible"
                    :viewDetailVisible.sync="viewDetailVisible"
                    :purchaseCompanyId="orderBaseInfo.purchaseCompanyId"
                    :id="id"
                    :type="type"
            />
        </e-dialog>
    </div>
</template>

<script>
import eDialog from '../../../components/common/e-dialog.vue';
import tableList from '../../../components/common/e-table-list';
import detailDialog from './detailDialog';
import api from '../../../api/order';
import eTab from './e-tabs.vue';

export default {
  name: 'stockAffirmDialog',
  components: {
    eDialog,
    tableList,
    detailDialog,
    eTab
  },
  props: {
    stockAffirmVisible: Boolean,
    orderBaseInfo: Object
  },
  data() {
    return {
      activeIndex: '0',
      tabArr: [
        {label: '石化采购意向单', id: '0',},
        {label: '石化商城订单', id: '1',},
      ],
      id: null,
      type: null,
      loading: true,
      viewDetailVisible: false,
      purchasePlanId: null,
      queryData: {
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      typeList: [
        {id: null, name: '全部'},
        {id: 1, name: '订货函'},
        {id: 2, name: '中选通知'},
        {id: 3, name: '中标通知'},
      ],
      tableData: [],
      tableLabel: [],
      oneTableLabel: [
        {label: '序号', slot: 'showIndex', align: 'center', width: '80'},
        {label: '石化采购意向单编号', param: 'stockAffirmId', align: 'center', width: '150', tooltip: true},
        {label: 'ERP订单号', param: 'erpNo', align: 'center', width: '120'},
        {
          label: '采购方式', param: '', align: 'center', render: (row) => {
            const obj = {
              1: '询比价',
              2: '公开招标',
              3: '邀请招标',
              4: '框架协议执行',
            };
            return obj[Number(row.stockType)];
          },
        },
        {
          label: '类型', param: '', align: 'center', render: (row) => {
            const arr = this.typeList.filter((item) => item.id === row.dataType) || [];
            return arr[0].name;
          },
        },
        {label: '石化采购意向单名称', param: 'stockAffirmName', align: 'center', width: '150', tooltip: true},
        {label: '备注', param: 'remark', align: 'center', tooltip: true},
        {label: '操作', param: '', align: 'center', slot: 'operate', fixed: 'right'},
      ],
      twoTableLabel: [
        {label: '序号', slot: 'showIndex', align: 'center', width: '80'},
        {label: '订单编号', param: 'orderNo', align: 'center', width: '180'},
        {label: 'ERP订单号', param: 'erpNo', align: 'center', width: '120'},
        {label: '采购商名称', param: 'purchaseCompany', align: 'center', tooltip: true},
        {label: '下单时间', param: 'submitTime', align: 'center', width: '160'},
        {label: '备注', param: 'remark', align: 'center', width: '140', tooltip: true},
        {label: '操作', param: '', align: 'center', slot: 'operate', fixed: 'right'},
      ],
    }
  },
  methods: {
    handleClick(val) {
      this.loading = true;
      this.tableLabel = [];
      this.activeIndex = val.index;
      this.dealSelect();
    },
    async dealSelect() {
      if (this.activeIndex === '0') {
        await this.queryOrderBind('queryOrderBind');
        this.tableLabel = this.oneTableLabel;
      } else if (this.activeIndex === '1') {
        await this.queryOrderBind('petrolMallOrderQueryOrderBind');
        this.tableLabel = this.twoTableLabel;
      }
    },
    viewDetail(id, type) {
      this.viewDetailVisible = true;
      this.id = id;
      this.type = type;
    },
    handleClose() {
      this.$emit('update:stockAffirmVisible', false);
    },
    async queryOrderBind(methodName) {
      let params = {
        orderId: this.orderBaseInfo.orderId,
        purchaseCompanyId: this.orderBaseInfo.purchaseCompanyId
      }
      const res = await api[methodName](params);
      if (res.code === '200') {
        this.tableData = res.data || [];
        this.tableData.forEach(item => {
          if (this.activeIndex === '0') {
            this.$set(item, 'type', 1)
          } else {
            this.$set(item, 'type', 2)
          }
        })

        this.loading = false;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.dealSelect();
    }, 500);

  }
};
</script>

<style scoped lang="scss">

</style>
